import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAll } from "../../../services/examGroup";
import {
  getAllGroupStart,
  getAllGroupSuccess,
  getAllGroupFailure,
} from "../reducer";

export function* getGroups({ payload }) {
  const response = yield call(fetchAll, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAllGroupSuccess(raw));
  } else {
    yield put(getAllGroupFailure(message || raw.error));
  }
}

export default function* onGetAllGroup() {
  yield takeLatest(getAllGroupStart.type, getGroups);
}
